import { showSuccessToast } from '@medflex/components/stories/Toast';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Button from '@medflex/components/stories/Button';

const useChatContacts = load => {
  const [isLoadingLocked, setIsLoadingLocked] = useState(false);
  const contacts = useSelector(state => state.chatContacts);
  const isLoadingContacts = useSelector(state => state.loading.effects.chatContacts.load);
  const dispatch = useDispatch();
  const loadChatContacts = () => dispatch.chatContacts.load();
  const { t } = useTranslation('messenger');
  const history = useHistory();

  useEffect(() => {
    if (!isLoadingLocked && load) {
      setIsLoadingLocked(true);
      loadChatContacts();
    }
  }, [isLoadingLocked]);

  const toggleArchive = async ({ id, archivedAt }) => {
    if (archivedAt) {
      await dispatch.chatContacts.dearchive({ contactId: id });
      showSuccessToast(
        t('useChatContacts.dearchive.title'),
        <Button
          kind="link"
          onClick={e => {
            e.preventDefault();
            history.push(`/chat/${id}`);
          }}
        >
          {t('useChatContacts.dearchive.text')}
        </Button>,
        { toastId: 'contactDearchived' },
      );
      return;
    }

    await dispatch.chatContacts.archive({ contactId: id });
    showSuccessToast(
      t('useChatContacts.archive.title'),
      <Button
        kind="link"
        onClick={e => {
          e.preventDefault();
          history.push(`/chat/${id}`);
        }}
      >
        {t('useChatContacts.dearchive.text')}
      </Button>,
      { toastId: 'contactArchived' },
    );
  };

  const findContactByUserId = useCallback(
    userId => contacts.find(c => c.user.id === userId),
    [contacts],
  );

  const findContactByPvsId = useCallback(
    pvsId => contacts.find(c => c.pvsId === pvsId),
    [contacts],
  );

  return {
    contacts,
    isLoadingContacts,
    loadChatContacts,
    toggleArchive,
    findContactByUserId,
    findContactByPvsId,
  };
};

export default useChatContacts;
